import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { StyleGuide } from './pages/StyleGuide';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="3ka4br4374fke">
      <Routes data-id="element-1" data-mp="3k8jeh6phyiiu">
        <Route path="/" element={<LandingPage data-id="element-3" data-mp="3k78ezj333wxj" />} data-id="element-2" data-mp="3k92qy7wdoeph" />
        <Route path="/styleguide" element={<StyleGuide data-id="element-5" data-mp="3fbt1is8zo31n" />} data-id="element-4" data-mp="3farhhy9zw67s" />
      </Routes>
    </BrowserRouter>;
}